"use client";

import React, { useState } from "react";
import { ChevronLeft, ChevronRight, DoorOpen, Star, Clock, ShieldCheck } from "lucide-react";
interface BeforeAfterSliderProps {
  beforeImage: {
    src: string;
    srcset: string;
    sizes: string;
    alt: string;
  };
  afterImage: {
    src: string;
    srcset: string;
    sizes: string;
    alt: string;
  };
  showSlider?: boolean;
}
function BeforeAfterSlider({
  beforeImage,
  afterImage,
  showSlider = true
}: BeforeAfterSliderProps) {
  const [sliderPosition, setSliderPosition] = useState(50);
  return <div className="relative w-full aspect-[4/3] overflow-hidden rounded-t-xl select-none group">
      {}
      <img src={afterImage.src} data-wvc-srcset={afterImage.srcset} data-wvc-sizes={afterImage.sizes} alt={afterImage.alt} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
      
      {}
      

      {}
      {showSlider && <>
          <div className="absolute inset-y-0 w-0.5 bg-white pointer-events-none" style={{
        left: `${sliderPosition}%`
      }}>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-accent rounded-lg flex items-center justify-center shadow-md transition-transform group-hover:scale-110">
              <ChevronLeft className="w-4 h-4 text-accent-foreground/70" />
              <ChevronRight className="w-4 h-4 text-accent-foreground/70" />
            </div>
          </div>

          <input type="range" min="0" max="100" value={sliderPosition} onChange={e => setSliderPosition(Number(e.target.value))} className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize z-10" aria-label="Comparaison avant et après" />
        </>}
    </div>;
}
export default function PatioRepairComparison() {
  const comparisons = [{
    title: "BEWEI Body Transformation",
    before: {
      src: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/1721724887.4657-abnehmen-im-liegen-in-mondsee-2nBaPQ.jpg?v=vbq86skx0ol",
      srcset: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/1721724887.4657-abnehmen-im-liegen-in-mondsee-2nBaPQ.jpg?v=nsfs6nnbwy-wvc-srcset",
      sizes: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/1721724887.4657-abnehmen-im-liegen-in-mondsee-2nBaPQ.jpg?v=zjht42feur-wvc-sizes",
      alt: "Silhouette avant le traitement BEWEI Body"
    },
    after: {
      src: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/vn62.avif?v=f8i6fwf0hwc",
      srcset: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/vn62.avif?v=diejds2ufcl-wvc-srcset",
      sizes: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/vn62.avif?v=dwd097e9ale-wvc-sizes",
      alt: "Silhouette après le traitement BEWEI Body"
    }
  }, {
    title: "Résultats Lymphdrainage",
    before: {
      src: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/vn62.avif?v=f6vvifeisgo",
      srcset: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/vn62.avif?v=0109u9n6t2czm-wvc-srcset",
      sizes: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/vn62.avif?v=3pz5bxut2l9-wvc-sizes",
      alt: "Rétention d'eau avant drainage"
    },
    after: {
      src: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/BC_AiL_BA_3.jpg?v=cqcn7nvkuj4",
      srcset: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/1721724887.4657-abnehmen-im-liegen-in-mondsee-2nBaPQ.jpg?v=kuc8fl2lq-wvc-srcset",
      sizes: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/1721724887.4657-abnehmen-im-liegen-in-mondsee-2nBaPQ.jpg?v=mlt0e0wngoc-wvc-sizes",
      alt: "Jambes légères après drainage"
    }
  }];
  const stats = [{
    icon: DoorOpen,
    value: "1200+",
    label: "Traitements réalisés"
  }, {
    icon: Star,
    value: "4.9",
    label: "Note moyenne clients"
  }, {
    icon: Clock,
    value: "30 min",
    label: "Consultation offerte"
  }, {
    icon: ShieldCheck,
    value: "100%",
    label: "Accompagnement expert"
  }];
  return <section className="py-12 md:py-20">
      <div className="container mx-auto px-4">
        <h2 className="font-bold mb-12 text-center !text-5xl !text-[rgba(122,28,135,1)]">Echte Erfolge</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {comparisons.map((comparison, index) => <div key={index}>
              
              <BeforeAfterSlider beforeImage={comparison.before} afterImage={comparison.after} />
            </div>)}
        </div>

        
      </div>
    </section>;
}